import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import type { SupporterVoicesCommentToScriptExperimentVariation } from '#src/app/pages/actions/pageContext';

import { useDisableVideoCreation } from './useDisableVideoCreation';
import { useUserRecordingCapability } from './useUserRecordingCapability';
import { useVideoFirstFlow } from './videoFirst';

export type CommentToScriptArm = Extract<
	SupporterVoicesCommentToScriptExperimentVariation,
	'v1_script' | 'v2_talking_points'
>;

const COMMENT_TO_SCRIPT_ARMS: ReadonlySet<SupporterVoicesCommentToScriptExperimentVariation> = new Set([
	'v1_script',
	'v2_talking_points',
]);

export function useCommentToScriptArm(): UseCommentToScriptArmResult {
	const {
		data: { supporterVoicesCommentToScriptExperiment },
	} = usePetitionActionsPageData();
	const disableVideoCreation = useDisableVideoCreation();
	const capability = useUserRecordingCapability();
	const {
		data: { hasRecordedVideo },
	} = useVideoFirstFlow();

	const { variation } = supporterVoicesCommentToScriptExperiment;

	if (disableVideoCreation || capability !== 'capable' || hasRecordedVideo) {
		return { arm: undefined, isRelevant: false };
	}

	return {
		// oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
		arm: COMMENT_TO_SCRIPT_ARMS.has(variation) ? (variation as CommentToScriptArm) : undefined,
		isRelevant: true,
	};
}

type UseCommentToScriptArmResult = Readonly<{
	arm: CommentToScriptArm | undefined;
	/** Whether the petition supports video and the viewer can record — the caller's exposure gate. */
	isRelevant: boolean;
}>;
